import { createSelector } from '@reduxjs/toolkit'

import { ESearchType } from '@/pages/RunReport/types'

import type { RootState } from '../../store'

export const selectRunReport = (state: RootState) => state.runReport

export const selectIsForCompanySearch = createSelector(
  selectRunReport,
  (slice) => slice.selectSearchType.searchType === ESearchType.Company,
)

export const selectSearchTarget = createSelector(selectRunReport, (slice) =>
  slice.selectSearchType.searchType === ESearchType.Company
    ? ({ kind: 'company', data: slice.companyInfo } as const)
    : ({ kind: 'subject', data: slice.subjectInfo } as const),
)
